module.exports = __webpack_public_path__ + "static/nicole-moudaber-ac5f8f3eb03bb60984139f087a838440.png";